<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate this book to Lieutenant Mark Coetzee who looked after my back during the most challenging five days of my life. Mark had left a long impression on me and I can honestly say people like him only come around once in a lifetime. Last but not least, my wife, Celeste; and daughters, Tarryn and Megan, who supported and encouraged me all the way.</p><br/>
<p style="text-indent:0em;">My brother Peter Swart who advised me on the early political events and dates in the Eastern Cape and Johann Swart who provided information which only a person who was in the Navy would have knowledge of. My friends Geroge Kalivitis, Shane Lang and Rory Collin for encouraging me to keep on writing. Thanks to Ettione Ferreria who assisted with editing the first version of the novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?a96cd752